//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  $dictKeyList: [
    {
      key: '10',
      name: '托管合同状态',
    },
  ],
  data() {
    return {
      filterForm: {
        contractType: 2, //2 托管合同 3流转合同
        contractNum: '',
        client: '',
        trustee: '',
        statusFlag: '',
        clientAccountId: '',
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      allFilters: {},
      contracts: [],
    }
  },
  created() {
    this.filterForm.clientAccountId = this.$route.query.$businessAccountId
    this.getContractList()
  },
  methods: {
    /**
     * @descripttion: 获取合同列表
     * @Author: juanjuanhui
     * @Date: 2021-11-23 20:35:33
     * @param {*}
     * @return {*}
     */
    getContractList() {
      this.allFilters = { ...this.filterForm }
      if (this.allFilters.statusFlag == -1) {
        delete this.allFilters.statusFlag
      }
      let { currentPage, pageSize } = this.pagination
      let params = { currentPage, pageSize }
      Object.assign(params, params, this.allFilters)
      this.$http.contract.getContractList(params).then((res) => {
        let { recordTotal, content: contracts } = res.data
        this.pagination.recordTotal = recordTotal
        this.contracts = contracts
      })
    },
    /**
     * @descripttion: 查询数据
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:07:16
     */
    handleFilterPro() {
      this.pagination.currentPage = 1
      this.getContractList()
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:08:07
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields()
      this.pagination.currentPage = 1
      this.getContractList()
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getContractList()
    },
    /**
     * @descripttion: 查看详情
     * @Author: juanjuanhui
     * @Date: 2021-11-24 14:05:16
     * @param {*} params
     * @return {*}
     */
    handleLookDetail(params) {
      this.$router.push({
        path: '/village/trustee/contract/detail',
        query: { id: params.id },
      })
    },
  },
}
